import * as React from 'react';

import { useBrandingContext } from '../../branding';
import { NegotiationState } from '../../generated/graphql';

const NegotiationStateSVG = (state: NegotiationState) => {
  const { illustrations } = useBrandingContext();
  const dataTest: Partial<{ [key in NegotiationState]: string }> = {
    [NegotiationState.ConfirmedByUser]: 'cy-confirmationSVG-CONFIRMED_BY_USER-img',
    [NegotiationState.Expired]: 'cy-confirmationSVG-EXPIRED-img',
    [NegotiationState.SentToBank]: 'cy-confirmationSVG-SENT_TO_BANK-img',
    [NegotiationState.ApprovedByBank]: 'cy-confirmationSVG-APPROVED_BY_BANK-img',
    [NegotiationState.RejectedByBank]: 'cy-confirmationSVG-REJECTED_BY_BANK-img',
  };
  const Illustration = illustrations.negotiationState[state];

  if (!Illustration) return null;

  return <Illustration dataTest={dataTest[state]} />;
};

export { NegotiationStateSVG };
